export default __webpack_public_path__ + "static/media/TylerLance.976a746b.jpg";